import { FunctionComponent, PropsWithChildren } from 'react'
import LoadingBackdrop from '../../../../../shared/components/LoadingBackdrop'
import { BreadCrumb, PageTitle, Content, ContainerCards } from './styles'
import { formatBreadCrumb } from '../../../../../shared/components/BasePage/formatBreadCrumb'

type IContainerPagePayments = {
  header?: React.ReactNode
  breadCrumb?: string
  loading?: boolean
} & PropsWithChildren<React.ReactNode>

const ContainerPagePayments: FunctionComponent<IContainerPagePayments> = ({
  header,
  breadCrumb,
  loading,
  children,
}) => {
  return (
    <>
      <LoadingBackdrop open={loading} />
      <Content>
        <BreadCrumb>
          <PageTitle>{formatBreadCrumb(breadCrumb)}</PageTitle>
        </BreadCrumb>
        <ContainerCards>
          {header && header}
          {children}
        </ContainerCards>
      </Content>
    </>
  )
}

export default ContainerPagePayments
